export enum Cursor {
    Pointer = 'pointer',
    Hovered = 'hovered',
    Locked = 'locked',
    NavOpen = 'navOpen',
}
